module.exports = __webpack_public_path__ + "static/cta-1-b4a0a440c74e65ed40a3d1bb60d4ee2b.jpg";